import useOnClickOutside from "hooks/useOnClickOutside";
import { DefaultCompProps } from "models/types";
import React, { FC, ReactNode, useRef, useState } from "react";

export interface ApDropDownMenuProps {
    header: ReactNode,
    body: ReactNode
};

const ApDropDownMenu: FC<DefaultCompProps & ApDropDownMenuProps & Record<string, any>> = (props) => {
    const { style, className, header, body, ...otherProps } = props;

    const ref = useRef(null),
        [collapse, setCollapse] = useState(true);

    useOnClickOutside([ref], () => setCollapse(true));

    const menuItemClick = () => setCollapse(true);

    return <div className="browse-by-menu-container" ref={ref}>
        <div className="ap-green browse-by-menu-header" onClick={() => setCollapse(!collapse)}>
            {header}
        </div>
        <div className={`browse-by-menu-detail pt-2 pb-2 ${collapse ? 'd-none' : 'd-block'}`} onClick={menuItemClick}>
            {body}
        </div>
    </div>
};

export default ApDropDownMenu;